import { darken, lighten, makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";
import { Height } from "@material-ui/icons";

/**
 * Contains style information for the snags page.
 */
export const SnagsPageStyles = makeStyles((theme: Theme) => ({
    root: { width: "100%" },
    // introduction: {
    //     borderBottom: "1px solid #ced4da",
    //     padding: "18px 18px 15px 18px",
    // },
    introductionTitle: {
        fontSize: "16px",
        fontWeight: "bold",
        lineHeight: "1.25",
    },
    snagsRow: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr 1fr",
        gap: "20px",
        width: "100%",
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: " 1fr 1fr",
        },
    },
    snag: {
        borderRadius: "3px",
        background: "#ECECEC",
        boxShadow: "none",
        "& > button": {
            height: "100%",
            "& > div.MuiCardContent-root": {
                padding: "16px",
                height: "100%",
                display: "flex",
                flexDirection: "column",
            },
        },
    },
    statusBanner: {
        minHeight: "24px",
        background: "#646464",
        color: "#ffffff",
        padding: "3px 3px 0px 0px",
        "& > h2": {
            fontSize: "12px",
            marginLeft: "15px",
        },
    },
    cardHead: {
        display: "flex",
        justifyContent: "space-between",
        gap: "10px",
        "& > div > h4": {
            fontSize: "10px",
            fontWeight: 700,
            lineHeight: "12px",
            color: "#191919",
            letterSpacing: "-0.15px",
        },
        "& > div > p": {
            fontSize: "10px",
            fontWeight: 400,
            lineHeight: "12px",
            color: "#191919",
            letterSpacing: "-0.15px",
        },
    },
    snagTitleRow: {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "3px",
    },
    snagTitle: {
        fontWeight: "bold",
        textTransform: "uppercase",
    },
    resolvedSnagTitle: {
        color: "#3AAA35",
    },
    rejectedSnagTitle: {
        color: "#DC3545",
    },
    snagContentRow: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
    },
    snagContentTitleRow: {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "3px",
    },
    snagDetails: {
        boxOrient: "vertical",
        display: "-webkit-box",
        lineClamp: 1,
        marginRight: "18px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        margin: "8px 0",
    },
    snagArrow: {
        alignItems: "center",
        display: "flex",
        "& svg": {
            fill: "#3aaa35",
            marginLeft: "-6px",
            marginRight: "-6px",
        },
    },
    // accordion: {
    //     margin: "0 !important",
    //     "& > div.MuiCollapse-container": {},
    // },

    titleRow: {
        padding: "27px 18px 15px 18px",
        display: "flex",
        justifyContent: "space-between",
        flex: "0 0 auto",
        "& > button": {
            padding: "0",
        },
        "& > h5": {
            padding: "0px",
        },
        "& .MuiSvgIcon-root": {
            margin: "-7px",
            fontSize: "35px",
        },
    },
    title: {
        fontSize: "20px",
        fontWeight: "bold",
    },
    titleBorder: {
        borderBottom: "1px solid #CED4DA",
        margin: "0 18px 16px",
    },
    accordionCard: {
        "& > div > div": {
            padding: "0px",
        },
        "& .MuiCollapse-container": {
            margin: "0px",
        },
    },

    introduction: {
        margin: "0 18px",
        padding: "18px 0",
    },
    sectionHeader: {
        background: "#3C3C3B",
        padding: "12px 20px",
        fontSize: "21px",
        lineHeight: "25px",
        color: "#FFFFFF",
        fontWeight: "bold",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        "& > h5": {
            fontSize: "21px",
            lineHeight: "25px",
            letterSpacing: "-0.53px",
            color: "#FFFFFF",
            opacity: 1,
            fontWeight: "bold",
            "& > span": {
                fontSize: "14px",
                lineHeight: "18px",
                color: "#fff",
                fontWeight: "normal",
                letterSpacing: "-0.21px",
                paddingLeft: "10px",
            },
        },
    },
    reportBtn: {
        background: "#449B23",
        borderRadius: "30px",
        opacity: 1,
        fontSize: "14px",
        lineHeight: "18px",
        color: "#fff",
        fontWeight: "normal",
        letterSpacing: "-0.21px",
        minWidth: "242px",
        padding: "11px 20px",
        "&:hover": {
            background: "#449B23",
        },
    },
    navigateToArrow: {
        alignItems: "center",
        display: "flex",
        "& svg": {
            fill: "#3aaa35",
            height: "24px",
            width: "24px",
        },
    },
    reportSnagModal: {},
    reportSnagModalBox: {
        backgroundColor: "#F5F5F5",
        boxShadow: "0px 3px 6px rgba(0,0,0,0.16)",
        borderRadius: "20px 20px 0 0",
        overflow: "hidden",
        [theme.breakpoints.up("md")]: {
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            maxWidth: "400px",
            borderRadius: "20px",
        },
    },
    reportSnagModalHead: {
        padding: "20px",
        background: "#3C3C3B",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        "& > h5": {
            fontSize: "21px",
            lineHeight: "25px",
            color: "#fff",
            fontWeight: 700,
            letterSpacing: "-0.53px",
        },
    },
    closeIcon: {
        height: "24px",
        widht: "24px",
        color: "#fff",
        padding: "0px",
    },
    reportSnagModalBody: {
        padding: "26px 20px",
        overflowY: "auto",
        height: "calc(100vh - 132px)",
        "& > .MuiFormControl-root": {
            borderRadius: "3px",
        },
    },
    [theme.breakpoints.down("sm")]: {
        reportBtn: {
            margin: "0 auto",
            marginTop: "30px",
            display: "block",
        },
        root: {
            "& .snagsMobileView": {
                "& .baseHeader": {
                    margin: "0px",
                },
                "& .baseViewAccordionBlock": {
                    padding: "20px 30px",
                },
            },
        },
        accordionDetails: {
            padding: "10px 0",
        },
        sectionHeader: {
            flexDirection: "column",
            "& > h5": {
                textAlign: "center",
                "& > span": {
                    fontSize: "10px",
                    lineHeight: "14px",
                    display: "block",
                    paddingLeft: "0px",
                },
            },
        },
        snagsRow: {
            gridTemplateColumns: "1fr 1fr",
            gap: "15px",
        },
    },
    [theme.breakpoints.down("xs")]: {
        reportBtn: {
            marginTop: "30px",
            width: "100%",
        },
        snagsRow: {
            gridTemplateColumns: " 1fr",
            gap: "8px",
        },
    },
}));
